/**
 * @file
 * Add responsive behavior for tables.
 *
 * Applies to all tables in full view-mode of content-types and entities,
 * which are not already wrapped by the responsive-table container.
 */

(function ($, Drupal) {
  Drupal.behaviors.responsiveTables = {
    attach: function attach(context) {
      once('awResponsiveTables', '.js-add-responsive-table table', context)
        .forEach(function(currentElement) {
          $(currentElement).wrap('<div class="responsive-table"></div>')
        });
    }
  };
})(jQuery, Drupal);
